var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallpaper",style:({'background-image':'url(' + _vm.imageUrl + ')'})},[_c('share-reason',{attrs:{"shareReason":_vm.shareReason}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }